import React, { Component } from "react";
import { connect } from "react-redux";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
} from "reactstrap";
import classnames from "classnames";
import "../../../../Assets/EnsembleStyles/DataExport.css";
import SelectDataSources from "./SelectDataSources";
import ExportFormat from "./ExportFormat";
import EmailRecipients from "./EmailRecipients";
import ExportRecurrence from "./ExportRecurrence";
// import Archive from "./Archive";
import ArchiveType from "./Archive";

var firstStartDateSelected = null,
  firstEndDateSelected = null,
  recurrence = null;
class DataExportTab extends Component {
  constructor(props) {
	super(props);
	this.toggle = this.toggle.bind(this);
	this.state = {
	  activeTab: "1",
	  disableTab: {
		IsExportFormatDisabled: true,
		IsSelectedDataSource: true,
		IsEmailRecipientsDisabled: true,
		IsExportRecurrenceDisabled: true,
		IsArchiveDisabled: true,
	  },
	  IsCreate: true,
	  isRadioValueActive: "",
	  isArchiveRadioActive: false,
	  startDate: null,
	  endDate: null,
	  IsFromReportSchedules: false,
	  IsDataMailed: false,
	  reportName: "",
	  description: "",
	  reportPeriod: "0D",
	  customStartDate: null,
	  customEndDate: null,
	  datalogIds: [],
	  RecurrenceDetails: {
		ExportRecurrenceList: [],
		deletedReportScheduleId: [],
		calendarEntries: [],
		ReportType: 0,
		AmplitudeRecurrenceList: [],
	  },
	  reportId:
		sessionStorage.getItem("SelectedReportID") !== null
		  ? sessionStorage.getItem("SelectedReportID")
		  : "0",
	  emailDetails: "",
	  isTimePeriodChanged: false,
	  onNextClicked: true,
	};
	this.setEmailRecipients = this.setEmailRecipients.bind(this);
	this.setExportFormat = this.setExportFormat.bind(this);
	this.setDatalogDefinitionIds = this.setDatalogDefinitionIds.bind(this);
	this.setExportRecurrence = this.setExportRecurrence.bind(this);
	this.setEmailDetails = this.setEmailDetails.bind(this);
	this.archiveRadioBtnCntrl = this.archiveRadioBtnCntrl.bind(this);
	this.setIsExportValid = this.setIsExportValid.bind(this);
  }

  componentWillMount() {
	var IsFromReportSchedules;
	IsFromReportSchedules = sessionStorage.getItem("IsFromReportSchedules");
	if (
	  IsFromReportSchedules !== undefined &&
	  IsFromReportSchedules !== null &&
	  IsFromReportSchedules === "true"
	) {
	  this.setState({ IsFromReportSchedules: true, activeTab: "3" });
	}
  }

  componentDidMount() {
	var SelectedReportDetails;
	SelectedReportDetails = sessionStorage.getItem("SelectedReportDetails");
	if (SelectedReportDetails !== undefined && SelectedReportDetails !== null) {
	  firstStartDateSelected = this.childRef.state.startDate;
	  firstEndDateSelected = this.childRef.state.endDate;
	  this.setState({ onNextClicked: false });
	}
  }

  toggle(tab) {
	if (this.state.activeTab !== tab) {
	  this.setState({ activeTab: tab });
	}
	if (this.state.IsCreate === true) {
	  const { disableTab } = this.state;
	  var enableTab = Object.entries(disableTab);
	  enableTab.map(([key, value], index) =>
		index < parseInt(tab)
		  ? (disableTab[key] = false)
		  : (disableTab[key] = true)
	  );
	  this.setState({ disableTab });
	}
  }

  setEmailRecipients(ToAddress) {
	var IsMailed =
	  ToAddress.trim() !== null && ToAddress.trim() !== "" ? true : false;
	this.setState({ IsDataMailed: IsMailed });
  }

  setIsExportValid(isActive) {
	recurrence = isActive;
  }
  /**
 * if scenarios being created are based of this  use case:
 * User did not enter a Schedule or a Recipient = Disable ‘Email report only’ radio dial button 
User did not enter a Schedule but does have a Recipient = Disable ‘Email report only’ radio dial button 
User did enter a Schedule but did not enter a Recipient = Disable ‘Email report only’ radio dial button 
User did enter a schedule and a Recipient = Enable ‘Email report only’ radio dial button 
*/
  archiveRadioBtnCntrl(isActive) {
	var isEmailSelected = isActive;
	var isDateSelected = recurrence;
	let radioValue;

	if (isEmailSelected === true && isDateSelected === false) {
	  radioValue = "Archive";
	} else if (isEmailSelected === false && isDateSelected === true) {
	  radioValue = "Archive";
	} else if (isEmailSelected === false && isDateSelected === false) {
	  radioValue = "Archive";
	} else if (isEmailSelected === true && isDateSelected === true) {
	  radioValue = "All";
	}

	this.setState({
	  isRadioValueActive: radioValue,
	});
  }

  setEmailDetails(data) {
	this.setState({
	  emailDetails: data,
	});
  }

  checkDateChanged(startDate, endDate) {
	if (this.state.onNextClicked) {
	  firstStartDateSelected = startDate;
	  firstEndDateSelected = endDate;
	}
	if (
	  new Date(firstStartDateSelected).getTime() !==
		new Date(startDate).getTime() ||
	  new Date(firstEndDateSelected).getTime() !== new Date(endDate).getTime()
	) {
	  this.setState({ isTimePeriodChanged: true });
	} else {
	  this.setState({ isTimePeriodChanged: false });
	}
  }

  setExportFormat(data) {
	this.checkDateChanged(data.StartDate, data.EndDate);
	this.setState({
	  reportName: data.ReportName,
	  reportPeriod: data.ReportPeriod,
	  description: data.Description,
	  customStartDate:
		data.CustomStartDate !== null
		  ? data.CustomStartDate.toLocaleString()
		  : null,
	  customEndDate:
		data.CustomEndDate !== null
		  ? data.CustomEndDate.toLocaleString()
		  : null,
	  startDate: data.StartDate.toLocaleString(),
	  endDate: data.EndDate.toLocaleString(),
	  onNextClicked: false,
	});
  }

  setExportRecurrence(data) {
	var Data = {
	  ExportRecurrenceList: data.ExportRecurrenceList,
	  deletedReportScheduleId: data.deletedReportScheduleId,
	  calendarEntries: data.calendarEntries,
	  ReportType: data.ReportType,
	  AmplitudeRecurrenceList: data.AmplitudeRecurrenceList,
	};
	this.setState({
	  RecurrenceDetails: Data,
	});
  }

  setDatalogDefinitionIds(data) {
	this.setState({
	  datalogIds: data,
	});
  }

  render() {
	var sendExportDetails = {
	  ReportName: this.state.reportName,
	  Description: this.state.description,
	  ReportPeriod: this.state.reportPeriod,
	  CustomStartDate: this.state.customStartDate,
	  CustomEndDate: this.state.customEndDate,
	  DatalogDefinitionIds: this.state.datalogIds,
	  IsMailed: this.state.IsDataMailed,
	  EmailReceipentDetails: this.state.emailDetails,
	};

	return (
	  <Row style={{ height: "100%" }}>
		<Col xs="6" sm="4" md="3" style={{ "padding-left": "17px" }}>
		  <Nav tabs vertical pills id="DataExportTabs">
			<NavItem
			  style={{
				display: this.state.IsFromReportSchedules ? "none" : "block",
			  }}
			>
			  <NavLink
				className={classnames({ active: this.state.activeTab === "1" })}
				disabled={this.state.disableTab.IsExportFormatDisabled}
				onClick={() => {
				  this.toggle("1");
				}}
			  >
				Export Details
			  </NavLink>
			</NavItem>
			<NavItem
			  style={{
				display: this.state.IsFromReportSchedules ? "none" : "block",
			  }}
			>
			  <NavLink
				className={classnames({ active: this.state.activeTab === "2" })}
				disabled={this.state.disableTab.IsSelectedDataSource}
				onClick={() => {
				  this.toggle("2");
				}}
			  >
				Select Data Sources
			  </NavLink>
			</NavItem>
			<NavItem
			  style={{
				paddingTop: this.state.IsFromReportSchedules ? "13px" : "0px",
			  }}
			>
			  <NavLink
				className={classnames({ active: this.state.activeTab === "3" })}
				disabled={this.state.disableTab.IsExportRecurrenceDisabled}
				onClick={() => {
				  this.toggle("3");
				}}
			  >
				{this.state.IsFromReportSchedules
				  ? "Export Recurrence"
				  : "Export Recurrence (optional)"}
			  </NavLink>
			</NavItem>
			<NavItem>
			  <NavLink
				className={classnames({ active: this.state.activeTab === "4" })}
				disabled={this.state.disableTab.IsEmailRecipientsDisabled}
				onClick={() => {
				  this.toggle("4");
				}}
			  >
				{this.state.IsFromReportSchedules
				  ? "Email Recipients"
				  : "Email Recipients (optional)"}
			  </NavLink>
			</NavItem>
			<NavItem>
			  <NavLink
				className={classnames({ active: this.state.activeTab === "5" })}
				disabled={this.state.disableTab.IsArchiveDisabled}
				onClick={() => {
				  this.toggle("5");
				}}
			  >
				Report History
			  </NavLink>
			</NavItem>
		  </Nav>
		</Col>
		<Col
		  xs="6"
		  sm="6"
		  md="7"
		  style={{ paddingTop: "20px" }}
		  className={"dataExport-section"}
		>
		  <TabContent activeTab={this.state.activeTab} id="DataExport">
			<TabPane tabId="1" id="ExportFormatTab">
			  <ExportFormat
				toggle={this.toggle}
				setExportFormat={this.setExportFormat}
				onRef={(ref) => (this.childRef = ref)}
			  />
			</TabPane>
			<TabPane tabId="2" id="SelectDataSourceTab">
			  <SelectDataSources
				toggle={this.toggle}
				startDate={this.state.startDate}
				endDate={this.state.endDate}
				setDatalogDefinitionIds={this.setDatalogDefinitionIds}
				isTimePeriodChanged={this.state.isTimePeriodChanged}
			  />
			</TabPane>
			<TabPane tabId="3">
			  <ExportRecurrence
				toggle={this.toggle}
				setExportRecurrence={this.setExportRecurrence}
				setArchiveEmailVal={this.setIsExportValid}
			  />
			</TabPane>
			<TabPane tabId="4">
			  <EmailRecipients
				toggle={this.toggle}
				setEmailRecipients={this.setEmailRecipients}
				setEmailDetails={this.setEmailDetails}
				setEmailExport={this.archiveRadioBtnCntrl}
				RecurrenceDetails={this.state.RecurrenceDetails}
			  />
			</TabPane>
			<TabPane tabId="5">
			  {/* <Archive
				toggle={this.toggle}
				isEmailandArchive={this.state.isRadioValueActive}
				RecurrenceDetails={this.state.RecurrenceDetails}
				{...sendExportDetails}
			  /> */}
			  <ArchiveType
				toggle={this.toggle}
				isEmailandArchive={this.state.isRadioValueActive}
				RecurrenceDetails={this.state.RecurrenceDetails}
				{...sendExportDetails}
			  />
			</TabPane>
		  </TabContent>
		</Col>
	  </Row>
	);
  }
}
export default connect(null, null)(DataExportTab);
